<template>
    <div class="quiz-container">
        <div class="quiz-content">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBackTwo">班级管理</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBack">{{ className }}</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>小测列表</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="quiz-list">
                <div class="course-list" v-if="!recordId">
                    <span class="select-text">课程筛选：</span>
                    <el-select
                        v-model="courseValve"
                        placeholder="请选择"
                        clearable
                        @change="selectCourse"
                    >
                        <el-option
                            v-for="courseItem in courseList"
                            :key="courseItem.course_id"
                            :label="courseItem.course_name"
                            :value="courseItem.course_id"
                        ></el-option>
                    </el-select>
                </div>
                <el-table
                    :data="quizList"
                    border
                    style="width: 100%; flex: 1; margin-top: 20px"
                    height="1%"
                    size="medium"
                    :header-cell-style="{
                        fontWeight: 'normal',
                        color: '#333',
                        background: '#f5f7fa',
                        textAlign: 'center'
                    }"
                    :cell-style="{ fontSize: '12px', color: '#333', textAlign: 'center' }"
                >
                    <el-table-column prop="paper_name" label="试卷名称"></el-table-column>
                    <el-table-column prop="t_name" label="创建人"></el-table-column>
                    <el-table-column prop="tran_create_time" label="发布时间"></el-table-column>
                    <el-table-column label="详情" width="400px">
                        <template slot-scope="scope">
                            <el-button type="primary" @click="toApproved(scope.row)"
                                >已批阅 {{ scope.row.approved_num }}</el-button
                            >
                            <el-button type="primary" @click="toUnApproved(scope.row)"
                                >未批阅 {{ scope.row.unapproved_num }}</el-button
                            >
                            <el-button type="primary" @click="toUnCommitted(scope.row)"
                                >未提交 {{ scope.row.uncommitted_num }}</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    class="pages-center"
                    background
                    style="margin: 20px 0"
                    :current-page.sync="quizPages.currentPageNum"
                    :page-size="quizPages.eachPageNum"
                    :total="quizPages.total"
                    layout="prev, pager, next, jumper"
                    @current-change="quizCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            classId: Number(this.$route.query.classId) || '',
            className: this.$route.query.className || '',
            recordId: Number(this.$route.query.recordId) || '',
            courseValve: '',
            courseList: [],
            quizList: [],
            quizPages: {
                currentPageNum: 1,
                eachPageNum: 10,
                total: 0
            }
        }
    },
    mounted() {
        this.getCourseList()
    },
    methods: {
        getCourseList() {
            this.$shttp.axiosGet(
                this.$api.admin_showTeaCourse,
                res => {
                    if (res.code === 200) {
                        this.courseList = res.data.course_list
                        this.courseValve = res.data.course_list[0].course_id
                        if (this.courseValve) {
                            this.getQuizList()
                        }
                    } else {
                        this.$message.error(res.msg)
                    }
                },
                err => {
                    console.log(err)
                }
            )
        },
        selectCourse(val) {
            this.getQuizList()
            this.courseValve = val
        },
        getQuizList() {
            let params = {
                c_id: this.classId,
                page: this.quizPages.currentPageNum,
                limit: this.quizPages.eachPageNum,
                course_id: this.courseValve
            }
            if (this.recordId) {
                params.course_record_id = this.recordId
            }
            this.$shttp.axiosGetBy(
                this.$api.getQuizList,
                params,
                res => {
                    if (res.code === 200) {
                        this.quizList = res.data.data
                        this.quizPages.total = res.data.total
                    }
                },
                err => {
                    console.log(err)
                }
            )
        },
        quizCurrentChange(val) {
            this.quizPages.currentPageNum = val
            this.getQuizList()
        },
        toApproved(row) {
            this.$router.push({
                path: '/teacherClass/quizApproved',
                query: {
                    quizId: row.id,
                    classId: row.c_id,
                    className: this.className,
                    paperName: row.paper_name
                }
            })
        },
        toUnApproved(row) {
            this.$router.push({
                path: '/teacherClass/quizUnApproved',
                query: {
                    quizId: row.id,
                    classId: row.c_id,
                    className: this.className,
                    paperName: row.paper_name
                }
            })
        },
        toUnCommitted(row) {
            this.$router.push({
                path: '/teacherClass/quizUnCommitted',
                query: {
                    quizId: row.id,
                    classId: row.c_id,
                    className: this.className,
                    paperName: row.paper_name
                }
            })
        },
        goBack() {
            this.$router.go(-1)
        },
        goBackTwo() {
            this.$router.go(-2)
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep .el-breadcrumb {
    .el-breadcrumb__inner {
        color: #000;
    }
}
.quiz-container {
    width: 100%;
    height: calc(100% - 40px);
    padding: 20px 0;
    .quiz-content {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        .quiz-list {
            display: flex;
            flex-direction: column;
            height: 1%;
            flex: 1;
            background: #fff;
            margin-top: 20px;
            .course-list {
                padding: 20px 20px 0;
            }
        }
    }
}
</style>
